import React from "react";

import { StockPageProvider } from "../../../lib/StockPage";
import StockPage from "./StockPage";

/**
 * Web stock route wrapper: supplies StockPageProvider from URL params.
 */
export default function StockPageRoute(props) {
  const market =
    props.match?.params?.marketId || props.match?.params?.market || "";
  const ticker =
    props.match?.params?.stockId || props.match?.params?.ticker || "";

  return (
    <StockPageProvider market={market} ticker={ticker} active>
      <StockPage {...props} />
    </StockPageProvider>
  );
}
